import { render, staticRenderFns } from "./StatisticProjectReportsBlankMainTable.vue?vue&type=template&id=1a657c8e&scoped=true&"
import script from "./StatisticProjectReportsBlankMainTable.vue?vue&type=script&lang=js&"
export * from "./StatisticProjectReportsBlankMainTable.vue?vue&type=script&lang=js&"
import style0 from "./StatisticProjectReportsBlankMainTable.vue?vue&type=style&index=0&id=1a657c8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a657c8e",
  null
  
)

export default component.exports